import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.elementId,
    style: _normalizeStyle(`width: 100%; height: ${_ctx.$props.height}px`)
  }, null, 12, _hoisted_1))
}